import * as S from './styled'

const ToggleButton = ({ isActive = false, onClick }) => (
  <S.Trail isActive={isActive} onClick={onClick}>
    <S.Pin />
  </S.Trail>
)

export default ToggleButton
